import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import {
  FaNetworkWired, FaProjectDiagram, FaServer, FaShieldAlt,
  FaEye, FaRobot, FaLaptop, FaSatelliteDish, FaBug, FaSearch
} from 'react-icons/fa';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const servicos = [
  {
    titulo: 'Conectividade Avançada',
    descricao: 'Garanta a máxima performance e estabilidade para suas operações críticas com nossas soluções de conectividade, oferecendo links dedicados de alta velocidade e confiabilidade.',
    icone: <FaNetworkWired />
  },
  {
    titulo: 'SD-WAN',
    descricao: 'Simplifique a gestão de redes e aumente a eficiência com nossa SD-WAN, permitindo conexões seguras e otimizadas entre várias localidades.',
    icone: <FaProjectDiagram />
  },
  {
    titulo: 'Colocation',
    descricao: 'Hospede seus servidores em nossos datacenters seguros e escaláveis, com monitoramento 24/7 e suporte técnico especializado.',
    icone: <FaServer />
  },
  {
    titulo: 'Anti-DDoS',
    descricao: 'Monitore, identifique e responda rapidamente a ameaças com nossa solução Anti-DDoS, garantindo a segurança contínua de sua rede.',
    icone: <FaShieldAlt />
  },
  {
    titulo: 'SIEM',
    descricao: 'Monitore, identifique e responda rapidamente a ameaças com nossa solução SIEM, garantindo a segurança contínua de sua rede.',
    icone: <FaEye />
  },
  {
    titulo: 'SOAR',
    descricao: 'Automatize a resposta a incidentes com SOAR, garantindo ações rápidas e coordenadas para neutralizar ameaças antes que causem danos.',
    icone: <FaRobot />
  },
  {
    titulo: 'EDR',
    descricao: 'Proteja seus dispositivos com EDR, uma solução robusta de detecção e resposta a ameaças avançadas em endpoints.',
    icone: <FaLaptop />
  },
  {
    titulo: 'SoC',
    descricao: 'Conte com nosso Centro de Operações de Segurança (SoC) para detecção proativa e resposta rápida a incidentes de segurança cibernética.',
    icone: <FaSatelliteDish />
  },
  {
    titulo: 'Scanner Anti-Hacker',
    descricao: 'Detecte e corrija vulnerabilidades em seus sistemas com o NeuroScan, prevenindo ataques e garantindo a segurança de seus dados.',
    icone: <FaBug />
  }, 
  {
    titulo: 'PenTest',
    descricao: 'Descubra falhas antes dos invasores com nossos testes de penetração, oferecendo uma análise completa de vulnerabilidades e recomendações de correção.',
    icone: <FaSearch />
  }
];

export default function Servicos() {
  return (
    <section className="section servicos" id="servicos">
      <h2>Nossos Serviços</h2>
      
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={25}
        slidesPerView={3}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000, // muda a cada 3 segundos
          disableOnInteraction: false, // continua passando mesmo depois do usuário interagir
        }}
        loop={true}
        breakpoints={{
          320: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1920: { slidesPerView: 4 },
        }}
      >
        {servicos.map((servico, index) => (
          <SwiperSlide key={index}>
            <div className="servico-card">
              <div className="icone">{servico.icone}</div>
              <h3>{servico.titulo}</h3>
              <p>{servico.descricao}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
